export default __webpack_public_path__ + "asset/img/icon-play-live~c73103ef.png";